import vClickOutside from 'v-click-outside'
import VueCreditCardValidation from 'vue-credit-card-validation'
const { bind, unbind } = vClickOutside.directive

export default (app) => {
  app.use(VueCreditCardValidation)

  app.directive('click-outside', {
    mounted(el, bindling) {
      bind(el, { value: bindling.value });
    },
    beforeUnmount(el) {
      unbind(el);
    },
  });
};
